module.exports = __webpack_public_path__ + "img/SHB.e9f3442b.svg";